import { ENCRYPT_GUID, ENCRYPT_DNF_GUID } from '../store/schema/EncryptionGUID';
import { InfoBarMessageId } from '../utils/InfoBarMessageId';
import { isConsumer } from 'owa-session-store';

export default function getEncryptionInfoBarMessageId(templateId: string): InfoBarMessageId {
    if (isConsumer()) {
        switch (templateId) {
            case ENCRYPT_GUID:
                return 'encryption';
            case ENCRYPT_DNF_GUID:
                return 'encryptionDoNotForward';
            default:
                return null;
        }
    } else {
        return 'irmInfoBar';
    }
}
